import { ReactComponent as CalendarIcon } from './calendar.svg';
import { ReactComponent as ClockIcon } from './clock.svg';
import { ReactComponent as CloseIcon } from './close.svg';
import { ReactComponent as ChevronDownIcon } from './chevron_down.svg';
import { ReactComponent as ChevronDownLightIcon } from './chevron_down_light.svg';

export { CalendarIcon, ChevronDownIcon, ChevronDownLightIcon, ClockIcon, CloseIcon };
